import React, { useState, useEffect } from 'react';
import QuoteBuilderForm from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderForm.jsx';

const Material = ({ config, disabled, options, uuid, item, extra_item_title,  navSection, colIndex, rowIndex, getExtraItems, disabledReason, navSectionColumnType}) => {
  return (
    <div>
      <QuoteBuilderForm
        config={config.material}
        disabled={disabled}
        disabledReason={disabledReason}
        options={options}
        section_uuid={uuid}
        navSectionColumnType={navSectionColumnType}
        item={item}
        extra_title={extra_item_title}
        navSection={navSection}
        colIndex={colIndex}
        rowIndex={rowIndex}
        getExtraItems={getExtraItems}
        />
    </div>
  )
}

export default Material;
